import { render, staticRenderFns } from "./ListPostSingle.vue?vue&type=template&id=23ab7866&"
import script from "./ListPostSingle.vue?vue&type=script&lang=js&"
export * from "./ListPostSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports